import React, { useState } from 'react';
import { Button } from '@chakra-ui/react';

import { Modal, Input } from 'shared-components';
import { useTranslation } from "react-i18next";

export interface IProps {
  uniStudentNumber?: string;
  onUpdate: (value: string) => void;
  onClose: () => void;
}

const EditUniStudentNumberModal = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const [uniStudentNumber, setUniStudentNumber] = useState(props.uniStudentNumber ?? '');

  const submit = () => {
    if (uniStudentNumber === '') {
      return;
    }
    props.onUpdate(uniStudentNumber);
    props.onClose();
  };

  return (
    <Modal
      id="edit-uni-student-number"
      show={true}
      title={t('dialogs:updateSecondaryStudentNumber')}
      onClose={props.onClose}
      footer={
        <Button id="save-changes" onClick={submit} isDisabled={uniStudentNumber === ''} variant={'solid'} size={'lg'}>
          Submit
        </Button>
      }
    >
      <Input
        id={'uni-student-number'}
        key={'uni-student-number'}
        label={t('dialogs:studentNumber')}
        value={uniStudentNumber}
        autoFocus={true}
        onChange={(evt: React.FormEvent<HTMLInputElement>) => setUniStudentNumber(evt.currentTarget.value)}
      />
    </Modal>
  );
};

export default EditUniStudentNumberModal;
